import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import {
  selectRenewalStrategyForUnit,
  selectRenewalStrategyForUnitLoading,
  selectUnit,
} from '@dashboards/selectors/dashboards.selectors';
import { UnitDetailsAbstract } from '@portfolio/components/unit-details/abstract/unit-details.abstract';
import { getEnumerationRadioListFunction } from '@shared/functions/get-enumeration-radio-list.function';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { RestUnitRenewalTargetModel } from '@shared/interfaces/renevals.interface';
import { RestUnitModel } from '@shared/interfaces/unit.interface';
import { selectFinishTypesEnumeration } from '@shared/selectors/enumeration.selectors';

@UntilDestroy()
@Component({
  selector: 'app-unit-details-description-section',
  templateUrl: './unit-details-description-section.component.html',
  styleUrls: ['./unit-details-description-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitDetailsDescriptionSectionComponent extends UnitDetailsAbstract implements OnInit, OnDestroy {
  restUnitTypeRentTargetModel: RestUnitRenewalTargetModel;
  renewalStrategyLoading$: Observable<boolean>;

  @Input() descriptionGroup: UntypedFormGroup;

  constructor(protected cdr: ChangeDetectorRef, private store: Store<{}>) {
    super(cdr);
  }

  get rent(): UntypedFormControl {
    return this.descriptionGroup?.get(this.UnitDetailsComponentForm.RENT) as UntypedFormControl;
  }

  get marketRent(): UntypedFormControl {
    return this.descriptionGroup?.get(this.UnitDetailsComponentForm.MARKETRENT) as UntypedFormControl;
  }

  get advertisedRent(): UntypedFormControl {
    return this.descriptionGroup?.get(this.UnitDetailsComponentForm.ADVERTISEDRENT) as UntypedFormControl;
  }

  get oldRent(): UntypedFormControl {
    return this.descriptionGroup?.get(this.UnitDetailsComponentForm.OLDRENT) as UntypedFormControl;
  }

  ngOnInit(): void {
    this.renewalStrategyLoading$ = this.store.select(selectRenewalStrategyForUnitLoading);

    this.store
      .select(selectRenewalStrategyForUnit)
      .pipe(
        untilDestroyed(this),
        filter((restUnitTypeRentTargetModel: RestUnitRenewalTargetModel) => !!restUnitTypeRentTargetModel),
        tap((restUnitTypeRentTargetModel: RestUnitRenewalTargetModel) => {
          this.restUnitTypeRentTargetModel = restUnitTypeRentTargetModel;
          this.cdr.detectChanges();
        })
      )
      .subscribe();

    this.store
      .select(selectUnit)
      .pipe(
        untilDestroyed(this),
        filter((unit: RestUnitModel) => !!unit),
        tap((unit: RestUnitModel) => {
          this.unit = unit;
          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {}
}
